import React from "react";
import Communication from "../../components/Communication";

function BrokerComPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <Communication />
      </div>
    </div>
  );
}

export default BrokerComPage;
